import { StringField } from "../../../types/types";
import { SectionList } from "../../SectionList/types/SectionList.types";
import {
  PrivacyFilterFields,
  PrivacyFilterProps,
  PrivacyFilter,
} from "../types/PrivacyFilter.types";

export class PrivacyFilterModel {
  private readonly fields?: PrivacyFilterFields;

  constructor(props: PrivacyFilterProps) {
    this.fields = props.fields;
  }

  get title(): StringField | undefined {
    return this.fields?.Title
  }

  get icon(): StringField | undefined {
    return this.fields?.Icon
  }

  get label(): StringField | undefined {
    return this.fields?.Label
  }

  get leftFilterLabel(): StringField | undefined {
    return this.fields?.LeftFilterLabel
  }

  get rightFilterLabel(): StringField | undefined {
    return this.fields?.RightFilterLabel
  }

  get leftFilterValues() {
    return this.fields?.LeftFilterValues
  }

  get rightFilterValues() {
    return this.fields?.RightFilterValues
  }

  get submitButtonLink() {
    return this.fields?.SubmitButtonLink
  }

  get placeholder() {
    return this.fields?.Placeholder
  }
}
